// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/userHome/emailTemplates/emailTemplateEdit/emailTemplateEdit.component.less
// module id = 451
// module chunks = 0